import React from 'react';
import { Box, Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { history } from 'umi';
import { useSelector } from 'dva';
import DataTableNativeML from '@/components/DataTableNativeML';
import { prizeTypeList, acceptWayList } from '../../constants';
import ResultStyled from './ResultStyled';

const Result = () => {
  const columns = [
    {
      align: 'center',
      title: '奖品名称',
      id: 'prizeName',
      key: 'prizeName',
      width: 272,
    },
    {
      title: '奖品类型',
      align: 'center',
      id: 'prizeType',
      key: 'prizeType',
      render: ({ prizeType }) => {
        return prizeTypeList?.find((i) => i.value === prizeType)?.name;
      },
    },
    {
      title: '领取方式',
      id: 'sendType',
      key: 'sendType',
      align: 'center',
      render: ({ sendType }) => {
        return acceptWayList?.find((i) => i.value === sendType)?.name;
      },
    },
    {
      title: '发放总量',
      id: 'quantity',
      key: 'quantity',
      align: 'center',
    },
    {
      title: '剩余数量',
      id: 'stock',
      key: 'stock',
      align: 'center',
    },

    {
      title: '中奖人数',
      id: 'winPeopleNum',
      key: 'winPeopleNum',
      align: 'center',
    },

    {
      title: '中奖次数',
      id: 'winNum',
      key: 'winNum',
      align: 'center',
    },
    {
      title: '中奖率',
      id: 'winRate',
      key: 'winRate',
      align: 'center',
      render: ({ winRate }) => {
        return `${winRate}%`;
      },
    },
  ];
  const loadingEffect = useSelector((state) => state.loading);
  const listLoading = loadingEffect.effects['luckyDrawReport/getLotteryReport'];
  const lotteryReportData = useSelector(
    (state) => state.luckyDrawReport?.lotteryReportData,
  );
  const { prizeList } = lotteryReportData || {};
  const handleExit = () => {
    history.goBack();
  };

  return (
    <ResultStyled>
      <Box>
        <Box className="table">
          <DataTableNativeML
            columns={columns}
            pageButton={false}
            loading={listLoading}
            data={prizeList}
            devicesMinWidth={1640}
            columnKey="id"
          ></DataTableNativeML>
        </Box>
      </Box>
      <Box className="button_group">
        <Button
          color="secondary"
          variant="contained"
          startIcon={<CloseIcon sx={{ width: '16px', height: '16px' }} />}
          onClick={() => {
            handleExit();
          }}
        >
          退出
        </Button>
      </Box>
    </ResultStyled>
  );
};
export default Result;
